import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class NodeGroupInput extends BaseNode {
    constructor() {
        super();
        this.name = 'Group Input';
        this.id = 'node_group_input';
        this.linkedFeature = 'general';

        this.outputs = [
            {
                name: 'Group Input',
                portId: 'output',
                params: [],
            },
        ];
    }
}
